module.exports = __webpack_public_path__ + "static/assets/6d8f498c48217b3346803a18b0a89949.svg";